export default __webpack_public_path__ + "static/media/not-allow.ecffa81e.png";